import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import type { City } from '@fitness-force/models';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  GetCity(BASE_URL: string, countryCode: string, stateCode: string) {
    const url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_CITY.replace('{countrycode}', countryCode).replace('{statecode}', stateCode);
    return this.http.get(url, { headers: this.httpOptions.headers }).pipe(map((res: any) => {
      if (res) {
        return res;
      } else {
        throwError;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }
}
